import React from "react";
import Typography from "../../modules/components/Typography";

export default function Reasons({weeklyTextCountLimit}) {
  return (
    <React.Fragment>
      <Typography variant="body2" marked="center" align="center">
        {"• Up to 6 watch subscriptions at once"}
      </Typography>
      <Typography variant="body2" marked="center" align="center">
        {`• Up to ${weeklyTextCountLimit} text notifications per week`}
      </Typography>
      <Typography variant="body2" marked="center" align="center">
        {"• Subscriptions that never expire"}
      </Typography>
    </React.Fragment>
  )
}